import { render } from "./AccountingView.vue?vue&type=template&id=534460ac"
import script from "./AccountingView.vue?vue&type=script&lang=js"
export * from "./AccountingView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__